var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyNow(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.387 10.115c-.643-.18-1.28-.364-1.847-.566-.755-.27-1.47-.6-1.94-1.07A3.5 3.5 0 117.55 3.53c.362.361.671.924.93 1.507a17.99 17.99 0 01.727 2.002l4.123-.275 7.514 7.514a1.5 1.5 0 010 2.121l-5.374 5.374a1.5 1.5 0 01-2.121 0l-7.53-7.53.568-4.128zm-3.08-2.342a2.5 2.5 0 113.536-3.536c.225.225.474.644.723 1.205.226.511.435 1.096.615 1.665l-.174.012A1.5 1.5 0 006.621 8.41l-.097.704a26.18 26.18 0 01-1.648-.508c-.735-.262-1.266-.532-1.568-.834zm5.165.317l-.398.026a.5.5 0 00-.462.431l-.734 5.341 5.36 5.36 6.08-6.082-5.374-5.374-3.453.23a33.63 33.63 0 01.227.889 1.35 1.35 0 11-.971.238 30.781 30.781 0 00-.275-1.06zm4.472 11.864l1.112 1.112a.5.5 0 00.707 0l5.374-5.374a.5.5 0 000-.707l-1.112-1.112-6.08 6.082zm-3.166-9.459A.35.35 0 109.283 10a.35.35 0 00.495.495z",
    fill: "#000"
  })));
}
export default SvgBuyNow;